import BaseHelper from './moment-base';
import moment from 'moment';

export default class Now extends BaseHelper {
  compute() {
    super.compute(...arguments);
    return moment.now();
  }
}
